<template>
  <div class="product-equipments">
    <div v-for="(products, i) in equipments" :key="i">
      <div v-for="(equipment, title, i) in products" :key="i">
        <ProductTable v-if="equipment.length" :title="equipments.length > 1 ? title : ''" :items="equipment" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductTable from './ProductTable'
import { mapState } from 'vuex'

export default {
  name: 'ProductEquipments',
  components: {
    ProductTable
  },
  computed: {
    ...mapState({
      equipments: state => state.productInfo.productInfo.equipments
    })
  }
}
</script>

<style scoped lang="sass">

</style>
